import { IS_DEV, env } from '../config'
export const STRIPE_DEV_FALLBACK = !IS_DEV && !window.location.href.match(/^https:/)
export const stripe = STRIPE_DEV_FALLBACK ? new Stripe(env.STRIPE_PUBLIC_KEY) : new Stripe(env.STRIPE_PUBLIC_KEY)

if (STRIPE_DEV_FALLBACK) {
    console.warn('Stripe loaded with development key fallback')
}

export const elements = stripe.elements()
export default stripe
